import { createApp } from 'vue';
import LoginApp from './LoginApp.vue';
// Reuse the OnBoarding Vuex store so the standalone /login page shares state,
// actions, and behaviour with the OnBoarding modal. One source of truth.
import store from '../on_boarding/store/store';

const loginElement = document.querySelector('#login');

if (loginElement) {
  const app = createApp(LoginApp);
  app.use(store);
  app.mount('#login');
}
